import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableHeader, CustomerSummary } from '@/types'

@Component
export default class CostumerListCompnent extends Vue {
  headers: TableHeader[] = [
    {
      text: 'Codigo',
      value: 'id'
    },
    {
      text: 'Descripcion',
      value: 'productName'
    },
    {
      text: 'Cantidad',
      value: 'quantity',
      align: 'end'
    },
    {
      text: 'Unidad de Medida',
      value: 'unitMeasure'
    },
    {
      text: 'Monto Total',
      value: 'totalAmount',
      align: 'end'
    }
  ]

  @Prop()
  items!: CustomerSummary

  @Prop()
  isLoading!: boolean
}
